<template>
  <div :class="tableData.length > 0? 'upload-compoment':'upload-compoment-border upload-compoment'">
    <el-upload
      :key="uploadKey"
      ref="upload"
      v-show="tableData.length == 0"
      class="upload-demo"
      drag
      :action="apiDomain"
      :multiple="multiple"
      :auto-upload="autoUpload"
      :show-file-list="false"
      :limit="limit"
      :accept="accept"
      :http-request="startUpload"
      :on-change="handleChange"
      :on-exceed="handleExceed"
      :before-upload="beforeAvatarUpload"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">点击拖动文件上传</div>
      <div class="el-upload__text" style="padding-top:10px">{{tips}}。严禁上传包含色情、暴力、反动等相关违法信息的文件</div>
    </el-upload>
    <el-table
      v-if="tableData.length > 0"
      :data="tableData"
    >
      <el-table-column
        prop="name"
        label="文件名称"
        header-align="center"
        width="200"
      >
        <template slot-scope="scope">
          <p class="file-name"><strong>{{scope.row.name}}</strong></p>
          <p class="file-size">{{scope.row.totalSize | transferFileSize}}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="percent"
        label="状态"
        header-align="center"
      >
        <template slot-scope="scope">
          <p class="upload-info">
            <span class="font-info">{{scope.row.uploadState | transferText}}</span>
            <span class="font-info speed" v-if="scope.row.uploadState == 1">{{scope.row.averageSpeed}}</span>
          </p>
          <el-progress :stroke-width="10" :percentage="scope.row.percent" :status="transferStatue(scope.row.uploadState)"></el-progress>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <!--
            uploadState 1: 开始上传  2: 暂停上传  3: 上传失败  4: 上传完成 5:再次进入续传
          -->
          <el-button type="text" :disabled="isPress" v-if="scope.row.uploadState == 2" @click="continueUpload(scope.row, scope.$index)">开始</el-button>
          <el-button type="text" :disabled="isPress"  v-if="scope.row.uploadState == 1" @click="pause(scope.row)">暂停</el-button>
          <el-button type="text" :disabled="isPress"  v-if="scope.row.uploadState == 3" @click="startUpload(scope.row, scope.$index)">重试</el-button>
          <el-button type="text" class="font-danger" @click="cancel(scope.row, scope.$index)">{{scope.row.uploadState == 4 ? '删除' : '取消'}}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { HttpClient } from '@oceans/transfer'
export default {
  name: 'uploadFile',
  props: {
    apiDomain: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: true
    },
    autoUpload: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 1
    },
    accept: {
      type: String,
      default: ''
    },
    tips: {
      type: String,
      default: '只能上传音/视频文件'
    }
  },
  data () {
    return {
      isPress: false,
      uploadKey: new Date().getTime(),
      client: null,
      tempIndex: null,
      tableData: []
    }
  },
  /* async mounted () {
    const rs = await HttpClient.listTaskAPI({
      status: '1000,0,2,1,4', // 任务状态，【可选】
      limit: 40, // 返回数据数量，每页数据条数
      page: 1, // 页码
      uId: this.userId,
      uploadServer: this.apiDomain // 必填，服务地址
    })
    try {
      const data = rs.data.result.docs
      this.tableData = [...data.map(item => {
        item.uploadState = 2
        item.percent = parseInt(item.percent.toFixed(2) * 100)
        return item
      })]
    } catch (e) {
      console.error(e)
    }
  }, */
  methods: {
    submit () {
      this.$refs.upload.submit()
    },
    transferStatue (statue) {
      switch (statue) {
        case 3:
          return 'exception'
        case 4:
          return 'success'
      }
    },
    handleChange (file, fileList) {
      this.uploadKey = new Date().getTime()
      this.$emit('beforeUpload', file, fileList)
    },
    beforeAvatarUpload (file) {
      // 文件类型进行判断
      if (['video/mp4', 'video/mov', 'video/avi', 'video/rmvb', 'video/mpg', 'video/mpeg', 'video/m4v', 'video/quicktime', 'video/flv', 'video/wmv', 'video/asf', 'video/vob', 'video/mkv', 'video/asf', 'video/wmv', 'video/rm', 'video/vob', 'video/ts', 'video/dat'].indexOf(file.type) == -1) {
        if (file.name.indexOf('ts') == -1) {
          this.$message.error('请上传正确的视频格式')
          return false
        }
      }
    },
    handleExceed (files) {
      if (files.length > this.limit) {
        this.$message.warning(`最多传输 ${this.limit} 个文件！`)
      }
    },
    async pause (row) {
      if (this.isPress || row.percent > 99) return
      this.isPress = true
      await row.client.stop()
      this.$emit('pauseUpload', row)
      this.$nextTick(() => {
        row.uploadState = 2
        setTimeout(() => {
          this.isPress = false
        }, 1000)
      })
    },
    continueUpload (row, index) {
      if (this.isPress) return
      if (row.client) {
        this.isPress = true
        row.uploadState = 1
        this.$nextTick(async () => {
          setTimeout(() => {
            this.isPress = false
          }, 1000)
          await row.client.start()
          setTimeout(() => {
            this.isPress = false
          }, 1000)
        })
      } else {
        this.tempIndex = index
        this.$refs.upload.$refs['upload-inner'].$refs.input.click()
      }
    },
    async cancel (row, index) {
      if (this.isPress) return
      this.isPress = true
      if (row.client) {
        await row.client.stop()
      }
      await HttpClient.deleteTaskAPI({
        id: row._id,
        uploadServer: this.apiDomain // 必填，服务地址
      })
      setTimeout(() => {
        this.isPress = false
      }, 1000)
      this.tableData.splice(index, 1)
      this.tempIndex = null
      this.$emit('complated', this.tableData)
    },
    startUpload (file, index) {
      // 判定是否为续传
      const that = this
      if (this.tempIndex != null) {
        file._id = this.tableData[this.tempIndex]._id
        index = this.tempIndex
        this.tempIndex = null
      }
      const time = new Date().getTime()
      let fileName = file.file.name.split('.')
      const ext = fileName.pop()
      // fileName = fileName.join().replace(/[\s|_|`|~|!|@|#|$|%|^|&|*|(|)|+|=|||{|}|'|:|;|'|,|[|\]|.|<|>|/|?|~|！|@|#|￥|%|……|&|*|（|）|——|+|||{|}|【|】|‘|；|：|”|“|’|。|，|、|？|\n|\r|\t]/g, '') + this.userId + '.' + ext
      fileName = fileName.join().replace(/[\s|_|`|~|!|@|#|$|%|^|&|*|(|)|+|=|||{|}|'|:|;|'|,|[|\]|.|<|>|/|?|~|！|@|#|￥|%|……|&|*|（|）|——|+|||{|}|【|】|‘|；|：|”|“|’|。|，|、|？|\n|\r|\t]/g, '') + '_' + time + '.' + ext
      const client = new HttpClient({
        file: file.file,
        uId: this.userId,
        restoreId: file._id || '',
        uploadServer: this.apiDomain,
        getFilePath: '/' + this.$moment(time).format('YYYY-MM-DD') + '/' + this.userId + '/' + fileName,
        flag: new Date().getTime() + '',
        md5Config: {
          // 文件md5计算方式，sample为局部计算方式，此方式计算速度很快，
          // all模式则计算整个文件，文件大时，会消耗很多时间，建议使用sample方式
          type: 'all'
        },
        onStart: (taskInfo) => {
          // index存在的情况下为重新上传  不存在的情况为首次上传
          if (index == null) {
            this.tableData.push(Object.assign(taskInfo, {
              uploadState: 1,
              client,
              file: file.file
            }))
          } else {
            this.tableData[index].uploadState = 1
          }
        },
        onProgress: (taskInfo) => {
          const curFile = that.tableData.filter(item => item._id === taskInfo._id)[0]
          curFile.percent = parseInt(taskInfo.percent.toFixed(2) * 100)
          curFile.averageSpeed = taskInfo.averageSpeed
        },
        onComplete: (taskInfo) => {
          const curFile = that.tableData.filter(item => item._id === taskInfo._id)[0]
          curFile.uploadState = 4
          Object.assign(curFile, taskInfo, {
            percent: 100
          })
          // 判断tableData内是否所有数据都已传输完
          if (!that.tableData.some(item => item.uploadState !== 4)) {
            that.$emit('complated', that.tableData)
          }
        },
        onError: async (e, taskInfo) => {
          try {
            const curFile = that.tableData.filter(item => item._id === taskInfo._id)[0]
            if (curFile.client) {
              await curFile.client.stop()
            }
            that.stopApi(taskInfo._id)
            that.$nextTick(() => {
              curFile.uploadState = 3
            })
            that.$message.error(e.message)
            that.$emit('complated', that.tableData)
          } catch (e) {
            console.error(e.message)
          }
        }
      })
      // 判定是否为刷新页面后上传
      if (index != null) {
        this.tableData.splice(index, 1, Object.assign({}, this.tableData[index], {
          uploadState: 1,
          client,
          file: file.file
        }))
      }
      this.$nextTick(async () => {
        if (file._id) {
          this.stopApi(file._id)
        }
        this.$emit('startUpload', file)
        await client.start()
      })
    },
    async stopApi (taskId) {
      await HttpClient.stopTaskAPI({
        taskId,
        uploadServer: this.apiDomain
      })
    }
  }
}
</script>
<style lang="less">
  .upload-compoment {
    background: #F8F8F8;

    text-align: center;
    .sdk-upload {
      background: none;
      border: none;
    }
    .el-upload-dragger{
      background: none;
      border: none;
    }
    .el-icon-upload:before {
      content: " ";
      display: block;
      height: 100px;
      width: 100px;
      background: url('../assets/upload1.png') no-repeat;
      background-size: 100%;
    }
    .upload-info {
      margin: 0;
      .speed {
        padding-left: 10px;
      }
    }
    .el-progress__text {
      font-size: 13px!important;
    }
    .file-name, .file-size {
      margin: 0;
    }
    .file-size {
      font-size: 10px;
      color: #999;
    }
  }
  .upload-compoment-border {
    border-radius: 4px;
    border: 1px solid #C8C8C8;
  }
</style>
